const DEFAULT_PRECISION = 2;

const CURRENCY_TO_PRECISION: Record<string, number> = {
  BHD: 3,
  BIF: 0,
  BYR: 0,
  CLF: 0,
  CLP: 0,
  DJF: 0,
  GNF: 0,
  IQD: 3,
  ISK: 0,
  JOD: 3,
  JPY: 0,
  KMF: 0,
  KRW: 0,
  KWD: 3,
  LYD: 3,
  OMR: 3,
  PYG: 0,
  RWF: 0,
  TND: 3,
  UGX: 0,
  UYI: 0,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XOF: 0,
  XPF: 0,
  XBT: 8,
};

const getCurrencyPrecision = (currencyCode: string): number => {
  return CURRENCY_TO_PRECISION[currencyCode] ?? DEFAULT_PRECISION;
};

export const convertDecimalToMinorUnits = (value: number, currency: string): number => {
  const precision = getCurrencyPrecision(currency);
  return Math.round(value * Math.pow(10, precision));
};

export const convertMinorUnitsToDecimal = (value: number, currency: string): number => {
  const precision = getCurrencyPrecision(currency);
  return value / Math.pow(10, precision);
};
